// Osobny moduł bez "use client": stałe importowane z pliku klienckiego są w komponencie serwerowym
// referencjami klienta, nie napisami (home-dashboard.tsx porównuje klucz banera po stronie serwera).
export const PKWPOZ_CONFERENCE_SLUG =
  "konferencja-pierwsze-kroki-w-poz-infekcje-szczepienia-antybiotykoterapia-jesien-2026";

// Klucz kampanii banera (audience) — ten sam rejestrujemy w home-banner-router.
export const PKWPOZ_BANNER_KEY = "pkwpoz-jesien-2026";
